// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$accountId/_user/alarms/configuration')({
  component: RouteComponent,
  staticData: { crumb: 'alarms:alarmConfiguration.title' },
});

function RouteComponent() {
  return <Outlet />;
}
